import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/packageOrderList';
import $R from 'plugins/tfs/platformConfigs/integrationMaps/routes';
import $POL from 'plugins/tfs/platformConfigs/integrationMaps/packageOrderList';
import $U from 'plugins/tfs/platformConfigs/integrationMaps/urls';
import React, { Fragment } from 'react';
import { DatePicker, Input } from 'antd';
import { Link } from 'react-router-dom';
import moment from 'moment';
import $S from 'theme/settings';
import { DatatableBox } from 'components/ui-ant/Datatable';
import Block from 'components/ui-ant/Block';
import Box from 'components/ui-ant/utility/box';
import Span from 'components/ui-ant/Span';
import Spinner from 'theme/Spinner';
import { dateFormatter, getStatusColor, objectSelector } from 'theme/utils';
import { createURL } from 'utils';
import giftIcon from 'theme/svg/gift-box.svg';
import PrintButton from 'plugins/tfs/pages/oms/PackageOrderList/printableView';
import PrintSettingsButton from 'plugins/tfs/pages/oms/PackageOrderList/printSettings/main';

// pageContainer
import DesktopView from '_pageContainers/oms/PackageOrderList/desktopView';

const DesktopViewGrid = (pageContext) => {
  const {
    props,
    packageFilterBarRef,
    orderDate,
    barcode,
    orderNumber,
    packageNumber,
    sku,
    firstName,
    lastName,
    queryObject,
    sortObject,
    selectedRowKeys,
    rowSelection,
    packageCountRenderer,
    statusId,
    filterTable,
    getSortObject,
    getEnumValue,
    handleChange,
    handleOrderDate,
  } = pageContext;

  function packageNumberRenderer(id, record) {
    return (
      <Link to={`${$R.PACKAGE_ORDER_DETAIL.path}/${record.id}`}>{id}</Link>
    );
  }

  function outputDateRenderer(value, packageOrder) {
    const { targetPackingDate } = packageOrder;
    const now = moment(new Date());
    const end = moment(targetPackingDate);
    const diff = end.diff(now, 'days');
    if (diff >= 0) {
      return dateFormatter(targetPackingDate);
    }
    return (
      <Span className='output-date'>
        {diff} {$ST.DAY}
      </Span>
    );
  }

  const columns = [
    {
      key: 1,
      dataIndex: $POL.PACKAGE_ORDER.NUMBER,
      title: $ST.TABLE.COL.PACKAGE_NUMBER,
      render: (cellData, record) => {
        const value = objectSelector(record, $POL.PACKAGE_ORDER.NUMBER);
        return packageNumberRenderer(value, record);
      },
    },
    {
      key: 2,
      dataIndex: $POL.PACKAGE_ORDER.ORDER_NUMBER,
      title: $ST.TABLE.COL.ORDER_NUMBER,
      render: (cellData, record) => {
        const orderNumber = record.order_has_gift_box ? (
          <div className='custom-order-title'>
            <span className='mr8'>{cellData}</span>
            <img style={{ height: '16px' }} src={giftIcon} alt='' />
          </div>
        ) : (
          cellData
        );
        return orderNumber;
      },
    },
    {
      key: 3,
      dataIndex: $POL.PACKAGE_ORDER.DATE_PLACED,
      title: $ST.TABLE.COL.ORDER_DATE,
      render: (cellData) => dateFormatter(cellData),
      sorter: true,
    },
    {
      key: 4,
      dataIndex: $POL.PACKAGE_ORDER.TARGET_PACKING_DATE,
      title: $ST.TABLE.COL.TARGET_PACKING_DATE,
      render: (cellData, record) => outputDateRenderer(cellData, record),
    },
    {
      key: 5,
      dataIndex: 'state.name',
      title: $ST.TABLE.COL.PACKAGE_STATUS,
      render: (cellData, record) => {
        const { name } = objectSelector(record, $POL.PACKAGE_ORDER.STATE);
        return name;
      },
    },
    {
      key: 6,
      dataIndex: 'stockLocation.name',
      title: $ST.TABLE.COL.STOCK_LOCATION,
      render: (cellData, record) => {
        const { name } = objectSelector(
          record,
          $POL.PACKAGE_ORDER.STOCK_LOCATION
        );
        return name;
      },
    },
    {
      key: 7,
      dataIndex: $POL.PACKAGE_ORDER.PACKAGE_ITEM_SET,
      title: $ST.TABLE.COL.PACKAGE_ITEM_SET,
      render: (cellData) => packageCountRenderer(cellData),
    },
    {
      key: 8,
      dataIndex: $POL.PACKAGE_ORDER.CHANNEL_NAME,
      title: $ST.TABLE.COL.CHANNEL_NAME,
    },
  ];

  const buildStatusBoxes = () => {
    const { statuses } = props;
    if (statuses.length > 0) {
      localStorage.setItem(
        'localPackageOrderStatuses',
        JSON.stringify(statuses)
      );
    }
    let localPackageStatuses = JSON.parse(
      localStorage.getItem('localPackageOrderStatuses')
    );
    let mappedStatuses = statuses.length > 0 ? statuses : localPackageStatuses;
    return (
      mappedStatuses !== null &&
      mappedStatuses.map(({ id, name, package__count: count }) => {
        const textStyle = { color: getStatusColor(id, 'package') };
        const clickedCardClass = statusId() === id ? 'clicked-box-border' : '';
        return (
          <Block
            key={id}
            onClick={() => filterTable(id)}
            className={`ant-col-lg-3 ant-col-md-6 ant-col-sm-12 ant-col-xs-24 small-card`}
          >
            <Box
              className={`stock-location--package-status ${clickedCardClass}`}
            >
              <Block className='stock-location--status-name' style={textStyle}>
                {name}
              </Block>
              <Block className='stock-location--package-title'>
                {$ST.PACKAGE_COUNT}
              </Block>
              <Block className='stock-location--status-count' style={textStyle}>
                {count || 0}
              </Block>
            </Box>
          </Block>
        );
      })
    );
  };

  const {
    pendings: { pendingPackageOrders },
  } = props;

  if (pendingPackageOrders) {
    return <Spinner centerOfPage />;
  }

  return (
    <Fragment>
      <Link className='breadcrumb-item' to={$R.PACKAGE_ORDER_LIST.path}>
        {$ST.PACKAGE_ORDERS}
      </Link>
      <div className='ant-col-xs-24 package-status-boxes'>
        <div className='pb20'>{buildStatusBoxes()}</div>
      </div>
      <div
        className='desktop-filters'
        id='desktopFilters'
        ref={packageFilterBarRef}
      >
        <div className='ant-col-xs-12 align'>
          <p className='input-label-text'> {$ST.FILTERS.ORDER_NUMBER}</p>
          <Input
            value={orderNumber}
            name='orderNumber'
            onChange={handleChange}
          />
        </div>
        <div className='ant-col-xs-12 align'>
          <p className='input-label-text'>{$ST.FILTERS.PACKAGE_NUMBER}</p>
          <Input
            value={packageNumber}
            name='packageNumber'
            onChange={handleChange}
          />
        </div>
        <div className='ant-col-xs-12 align'>
          <p className='input-label-text'>{$ST.FILTERS.CUSTOMER_NAME}</p>
          <Input value={firstName} name='firstName' onChange={handleChange} />
        </div>
        <div className='ant-col-xs-12 align'>
          <p className='input-label-text'>{$ST.FILTERS.CUSTOMER_LASTNAME}</p>
          <Input value={lastName} name='lastName' onChange={handleChange} />
        </div>
        <div className='ant-col-xs-12 align'>
          <p className='input-label-text'>{$ST.FILTERS.BARCODE}</p>
          <Input value={barcode} name='barcode' onChange={handleChange} />
        </div>
        <div className='ant-col-xs-12 align'>
          <p className='input-label-text'>{$ST.FILTERS.PRODUCT_SKU}</p>
          <Input value={sku} name='sku' onChange={handleChange} />
        </div>
        <div className='ant-col-xs-12 align'>
          <p className='input-label-text'>{$ST.FILTERS.ORDER_DATE}</p>
          <DatePicker
            value={orderDate}
            size='medium'
            className='full-width'
            placeholder={$ST.SELECT_DATE}
            format='DD.MM.YYYY dddd'
            onChange={(date) => handleOrderDate(date)}
            showToday={false}
          />
        </div>
      </div>
      <div className='ant-col-xs-24' style={{
        position: 'relative',
      }}>
        {/* Waiting and Shipped status control */}
        {[35, 44].includes(statusId()) && (
          <div style={{
            position: 'absolute',
            top: '22px',
            left: '160px',
            marginBottom: '18px',
            display: 'flex',
            gap: '12px',
          }}>
            {$S.isPackageOrderListPrintable && (
              <PrintButton
                selectedRowKeys={selectedRowKeys}
                sortingFilter={sortObject}
                url={$U.OMS.PACKAGE_ORDER_LIST}
                statusId={statusId()}
                enumValue={getEnumValue}
              />
            )}
            {$S.isPackageOrderListPrintable && <PrintSettingsButton />}
          </div>
        )}
        <DatatableBox
          rowKey='id'
          subtitle={<div style={{ minHeight: '40px' }}>{$ST.ORDER_PACKAGES}</div>}
          exportable={false}
          columns={columns}
          locale={{ emptyText: $ST.PACKAGE_NOT_FOUND }}
          url={
            $U.BASE_URL + createURL($U.OMS.PACKAGE_ORDER_LIST, [], queryObject)
          }
          filter={{ state: statusId() }}
          remote={true}
          rowSelection={rowSelection}
          pagination
          getSorting={getSortObject}
        />
      </div>
    </Fragment>
  );
};

export default DesktopView(DesktopViewGrid);


// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/oms/PackageOrderList/desktopView/index.js